import { Menu, MenuItem } from '@mui/material';
import { useState, useRef } from 'react';
import { FileOptions } from './styles';
import { MoreVert } from '@mui/icons-material';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { toKebabCase } from '@/utils';

export const AttachmentMenu = ({
  isPdf,
  isVideo,
  canViewSideBySide,
  handleSBSMode,
  handleRemoveAttachment,
  handleDownloadAttachment,
  index,
  location,
}: {
  isPdf?: boolean;
  isVideo?: boolean;
  canViewSideBySide?: boolean;
  handleSBSMode?: () => void;
  handleRemoveAttachment?: (index: number) => void;
  handleDownloadAttachment?: (index: number) => void;
  index: number;
  location: string;
}) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>(undefined);
  const mainRef = useRef(null);
  const handleMenuClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    setAnchorElement(mainRef.current ?? undefined);
  };

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAnchorElement(undefined);
  };
  const handleRemove = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!handleRemoveAttachment) return;
    handleRemoveAttachment(index);
    handleClose(event);
  };

  const handleDownload = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!handleDownloadAttachment) return;
    handleDownloadAttachment(index);
    handleClose(event);
  };

  const handleSBSModeClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!handleSBSMode) return;
    handleSBSMode();
    handleClose(event);
  };

  return (
    <>
      <FileOptions
        ref={mainRef}
        onClick={handleMenuClick}
        disableRipple
        isPdf={isPdf}
        isVideo={isVideo}
      >
        <MoreVert sx={{ fontSize: '1.2rem', color: 'primary.500' }} />
      </FileOptions>

      <Menu
        elevation={0}
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiMenuItem-root': {
            gap: '0.8rem',
          },
        }}
      >
        {canViewSideBySide && (
          <MenuItem
            onClick={handleSBSModeClick}
            className={`${location}-media-${toKebabCase('SideBySide')}`}
          >
            <AbyssIcon iconName="split-view" size="md" />
            <span>View side-by-side</span>
          </MenuItem>
        )}
        <MenuItem onClick={handleRemove} className={`${location}-media-${toKebabCase('Remove')}`}>
          <AbyssIcon iconName="trash" size="md" />
          <span>Remove</span>
        </MenuItem>
        <MenuItem
          onClick={handleDownload}
          className={`${location}-media-${toKebabCase('Download')}`}
        >
          <AbyssIcon iconName="file-download-line-dark" size="md" />
          <span>Download</span>
        </MenuItem>
      </Menu>
    </>
  );
};
